import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZarazeniPujcovnaPredmet = {
	name: NAME,
	apiProvider,
	router,
};
